<template>
  <div>
    <div v-if="hasRequestChangeFlag" class="mb-2">
      <span>
        <v-icon color="error">
          mdi-pin
        </v-icon>
      </span>
      <span>
        = รอการตรวจสอบจากกองบริหารงานบุคคล ,
      </span>
      <span>
        <v-icon color="success">
          mdi-check
        </v-icon>
      </span>
      <span>
        = ตรวจสอบแล้ว
      </span>
    </div>

    <v-data-table
      :headers="modifiedHeaders"
      :items="items"
      :loading="loading"
      mobile-breakpoint="0"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="(item, row_index) in items" :key="`row${row_index}`">
            <td
              v-for="(header, col_index) in headers"
              :key="`col${col_index}`"
              class="text-no-wrap"
            >
              <div v-if="header.meta === 'requestChangeFlag'">
                <span v-if="item.requestChangeFlag">
                  <v-icon color="error">
                    mdi-pin
                  </v-icon>
                </span>
                <span v-else>
                  <v-icon color="success">
                    mdi-check
                  </v-icon>
                </span>
              </div>
              <div v-else-if="header.meta === 'clickAction'">
                <v-btn icon @click="$emit('action', item)">
                  <v-icon>{{ header.icon || 'mdi-file-document' }}</v-icon>
                </v-btn>
              </div>
              <div v-else v-html="item[header.value] || '-'" />
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    modifiedHeaders() {
      return this.headers.map(header => {
        header.class = 'grey lighten-3 text-body-2 black--text'
        return header
      })
    },

    hasRequestChangeFlag() {
      const find = this.headers.find(item => {
        return item.value === 'requestChangeFlag'
      })

      return !!find
    }
  }
}
</script>

<style lang="scss" scoped></style>
